export default __webpack_public_path__ + "5094531f6ec7156452e87ce6ee585897.png";